module.exports = __webpack_public_path__ + "static/media/netflix.00f4512d.svg";